import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

export async function getManageAppointment(token) {
  const res = await axios.get(`${API}/portal/appointments/manage/${token}`);
  return res.data;
}

export async function cancelManageAppointment(token, payload) {
  const res = await axios.post(
    `${API}/portal/appointments/manage/${token}/cancel`,
    payload || {}
  );
  return res.data;
}

export async function rescheduleManageAppointment(token, payload) {
  const res = await axios.post(
    `${API}/portal/appointments/manage/${token}/reschedule`,
    payload
  );
  return res.data;
}

export async function getManageAvailability({ token, date, technicianId, bucketMinutes }) {
  const params = { token, date };
  if (technicianId) params.technician_id = technicianId;
  if (bucketMinutes) params.bucket_minutes = bucketMinutes;
  const res = await axios.get(`${API}/portal/appointments/availability`, { params });
  return res.data;
}
